var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.internalValue == 1)?_c('span',{staticClass:"label published"},[_c('i',{staticClass:"icon icon-check"})]):_vm._e(),_vm._v(" "),(_vm.internalValue == 0)?_c('span',{staticClass:"label unpublished"},[_c('i',{staticClass:"icon icon-icon_close"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f700dce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checked.vue
// module id = 880
// module chunks = 0